"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("./styles.scss");
const Radio = (props) => {
    const { label, checked = false, onChange, disabled, name } = props;
    const radioClasses = (0, classnames_1.default)("c-radio", { "c-radio--disabled": disabled });
    const labelLink = new Date().getTime().toString() + Math.random().toString();
    return (react_1.default.createElement("label", { htmlFor: labelLink, className: radioClasses },
        react_1.default.createElement("span", { className: "c-radio__label" }, label),
        react_1.default.createElement("input", { type: "radio", name: name, id: labelLink, disabled: disabled, onChange: ({ target }) => onChange === null || onChange === void 0 ? void 0 : onChange(target.checked), checked: checked, className: "c-radio__input" }),
        react_1.default.createElement("div", { className: "c-radio__checkmark-container" },
            react_1.default.createElement("span", { className: "c-radio__checkmark" }))));
};
exports.Radio = Radio;
